export default "__VITE_ASSET__C1jQY3YF__"